import React from "react";
import ReactDOM from "react-dom";

import { NavLink } from "react-router-dom";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import logo from "./logo.jpg";

import NavigationItems from "./navbarItems";

import "./navbar.css";

function Sidebar(props) {
  return ReactDOM.createPortal(
    <nav className="side-nav">
      <ul className="main-nav__items">
        {/* <li className="navigation-item">
          <NavLink to="/">About</NavLink>
        </li>
        <li className="navigation-item">
          <NavLink to="/services">Services</NavLink>
        </li>
        <li className="navigation-item">
          <NavLink to="/contacts">Contacts</NavLink>
        </li> */}
        <NavigationItems onClick={props.onClick} />
      </ul>
    </nav>,
    document.getElementById("sidebar")
  );
}

export default Sidebar;
